import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export abstract class RoleService {
	public roles$!: Observable<string[] | undefined>;

	protected constructor() {}
}
